export type DeliveryAddressUi = {
  deliveryAddresses: DeliveryAddress[];
  saveDisabled: boolean;
  addingNewAddress?: boolean;
};

export type DeliveryAddress = {
  id: string;
  title: string;
  subtitle: string;
  isFavorite: boolean;
};

export const initialState: DeliveryAddressUi = {
  deliveryAddresses: [],
  saveDisabled: true,
};
